export const PlacementType = Object.freeze({
	taskViewTab: 'TASK_VIEW_TAB',
	taskViewSidebar: 'TASK_VIEW_SIDEBAR',
	taskViewTopPanel: 'TASK_VIEW_TOP_PANEL',
	taskUserListToolbar: 'TASK_USER_LIST_TOOLBAR',
	taskGroupListToolbar: 'TASK_GROUP_LIST_TOOLBAR',
	taskListContextMenu: 'TASK_LIST_CONTEXT_MENU',
	taskRobotDesignerToolbar: 'TASK_ROBOT_DESIGNER_TOOLBAR',

	taskViewSlider: 'TASK_VIEW_SLIDER',
	taskViewDrawer: 'TASK_VIEW_DRAWER',
});
